const mutations = {
  getTncWebs: (state, tncweb) => {
    state.tncweb = tncweb;
  },
  getTncUsers: (state, tncuser) => {
    state.tncuser = tncuser;
  },
  getTncHeros: (state, tnchero) => {
    state.tnchero = tnchero;
  },
  getTncContent: (state, tnc_id) => {
    state.tnc_id = tnc_id;
  },
  postTncweb: (state, new_tncweb) => {
    state.tncweb.push(new_tncweb);
  },
  postTncuser: (state, new_tncuser) => {
    state.tncuser.push(new_tncuser);
  },
  postTnchero: (state, new_tnchero) => {
    state.tnchero.push(new_tnchero);
  },
  putTncweb: (state, payload) => {
    state.tncweb = state.tncweb.map((tncweb) => {
      if (tncweb.tnc_id === payload.id) {
        return Object.assign({}, tncweb, payload.tncData);
      }
      return tncweb;
    });
  },
  putTncuser: (state, payload) => {
    state.tncuser = state.tncuser.map((tncuser) => {
      if (tncuser.tnc_id === payload.id) {
        return Object.assign({}, tncuser, payload.tncData);
      }
      return tncuser;
    });
  },
  putTnchero: (state, payload) => {
    state.tnchero = state.tnchero.map((tnchero) => {
      if (tnchero.tnc_id === payload.id) {
        return Object.assign({}, tnchero, payload.tncData);
      }
      return tnchero;
    });
  },
  delTncweb(state, payload) {
    const index = state.tncweb.findIndex(tncweb => tncweb.tnc_id == payload.id);
    state.tncweb.splice(index, 1);
  },
  delTncuser(state, payload) {
    const index = state.tncuser.findIndex(tncuser => tncuser.tnc_id == payload.id);
    state.tncuser.splice(index, 1);
  },
  delTnchero(state, payload) {
    const index = state.tnchero.findIndex(tnchero => tnchero.tnc_id == payload.id);
    state.tnchero.splice(index, 1);
  },
};

export default mutations;
